import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TransactionMatching = ({ transactions }) => {
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const getStatusBadge = (status) => {
    const statusMap = {
      pending_review: { label: 'Pending Review', color: 'bg-warning/10 text-warning', icon: 'Clock' },
      payment_failed: { label: 'Payment Failed', color: 'bg-error/10 text-error', icon: 'XCircle' },
      unmatched: { label: 'Unmatched', color: 'bg-accent/10 text-accent', icon: 'AlertCircle' },
      matched: { label: 'Matched', color: 'bg-success/10 text-success', icon: 'CheckCircle' }
    };
    return statusMap?.[status] || statusMap?.unmatched;
  };

  const handleMatch = (transactionId) => {
    console.log('Matching transaction:', transactionId);
  };

  const handleInvestigate = (transactionId) => {
    console.log('Investigating transaction:', transactionId);
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            Transaction Matching
          </h3>
          <p className="text-sm text-muted-foreground">
            {transactions?.length} unmatched items requiring attention
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-250">
          <Icon name="RefreshCw" size={18} />
          <span className="text-sm font-medium">Sync Now</span>
        </button>
      </div>
      <div className="space-y-3">
        {transactions?.map((transaction) => {
          const statusBadge = getStatusBadge(transaction?.status);
          return (
            <div key={transaction?.id} className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors duration-250">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-sm font-semibold text-foreground">{transaction?.id}</span>
                    <span className={`text-xs px-2 py-1 rounded-full ${statusBadge?.color} flex items-center gap-1`}>
                      <Icon name={statusBadge?.icon} size={12} />
                      {statusBadge?.label}
                    </span>
                  </div>
                  <div className="text-sm text-muted-foreground mb-1">{transaction?.description}</div>
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="Calendar" size={12} />
                      {transaction?.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="CreditCard" size={12} />
                      {transaction?.paymentMethod}
                    </span>
                    {transaction?.member !== 'N/A' && (
                      <span className="flex items-center gap-1">
                        <Icon name="User" size={12} />
                        {transaction?.member}
                      </span>
                    )}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-lg font-semibold text-foreground data-text mb-2">
                    ${transaction?.amount?.toFixed(2)}
                  </div>
                  <div className="text-xs text-muted-foreground">{transaction?.type}</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Check"
                  iconPosition="left"
                  onClick={() => handleMatch(transaction?.id)}
                >
                  Match
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Search"
                  iconPosition="left"
                  onClick={() => handleInvestigate(transaction?.id)}
                >
                  Investigate
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransactionMatching;